import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { withStyles, Grid } from '@material-ui/core';
import { FHEContainer, FHEContainerScroll, FHEContainerForm, FHETitle, FHEItemText, FHEDivider } from 'data/components';
import { Toastr, tools } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import { SvgTicket } from 'data/common/iconsvg';
import { TicketHistory } from '../../components';
import { getTicketDetails, getTicketHistory } from '../../data/Ticket/actions';

class TicketDetail extends PureComponent {
    static propTypes = {
        history: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired,
        managements: PropTypes.object.isRequired,
        ticketId: PropTypes.string.isRequired,
        getTicketDetails: PropTypes.func.isRequired,
        getTicketHistory: PropTypes.func.isRequired
    };

    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {
            error: null,
            loading: true,
            ticket: {},
            ticketsHistory: {},
            nbRemainingLines: 0
        };
    }

    componentDidMount() {
        this.getTicketDetailsAndHistory();
    }

    getTicketDetailsAndHistory = () => {
        const { profile, history } = this.props;
        this.getTicketDetails().then(() => {
            if (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('ticketHistoryList'))
                this.getTicketHistory();
        });
    };

    getTicketDetails = () => {
        const { getTicketDetails, ticketId, managements } = this.props;
        this.setState({ loading: true });
        return getTicketDetails(ticketId)
            .then(data => {
                const ticket = data.ticket;
                ticket.managementLabel = managements.getIn([ticket.managementId.toString(), 'libelle'], '');

                this.setState({
                    ticket,
                    loading: false,
                    error: null
                });
            })
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
                this.setState({ error: message, loading: false });
                throw err;
            });
    };

    getTicketHistory = () => {
        const { ticketsHistory } = this.state;
        const { getTicketHistory, ticketId, profile, history } = this.props;
        const rightTicketHistoryList = profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('ticketHistoryList');
        if (rightTicketHistoryList) {
            return getTicketHistory(ticketId, 0, Object.keys(ticketsHistory).length === 0 ? 10 : Object.keys(ticketsHistory).length)
                .then(data => {
                    this.setState({
                        ticketsHistory: data.ticketsHistory,
                        nbRemainingLines: data.remainingLines,
                        error: null
                    });
                })
                .catch(err => {
                    const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                    Toastr.error(message);
                    this.setState({ error: message });
                });
        }
    };

    loadMoreTicketHistory = () => {
        const { getTicketHistory, ticketId, history } = this.props;
        const { ticketsHistory } = this.state;
        return getTicketHistory(ticketId, Object.keys(ticketsHistory).length, 10)
            .then(data => {
                this.setState({
                    ticketsHistory: { ...ticketsHistory, ...data.ticketsHistory },
                    nbRemainingLines: data.remainingLines
                });
            })
            .catch(() => {
                Toastr.error(Translator.translate(`generic.ticketing.actions.loadMoreTicketHistoryError`));
            });
    };

    renderForm = () => {
        const { ticket } = this.state;
        const { history } = this.props;
        return (
            <FHEContainerForm>
                <Grid container spacing={3}>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText itemTitle={Translator.translate('general.table.column.ref')} itemContent={ticket.ref} />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText itemTitle={Translator.translate('general.table.column.residence')} itemContent={ticket.managementLabel} />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.status')}
                            itemContent={Translator.translate(`generic.ticketing.state.${ticket.state}`)}
                        />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText
                            itemTitle={Translator.translate('general.table.column.type')}
                            itemContent={ticket.type ? Translator.translate(`generic.ticketing.type.${ticket.type}`) : null}
                        />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText itemTitle={Translator.translate('general.table.column.createdAt')} itemContent={ticket.createdAt} />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText itemTitle={Translator.translate('general.table.column.creatorLabel')} itemContent={ticket.creator.label} />
                    </Grid>
                    <Grid container item sm={12} md={6} lg={4}>
                        <FHEItemText itemTitle={Translator.translate('general.table.column.assignmentLabel')} itemContent={ticket.assignment.label} />
                    </Grid>
                    <Grid container item sm={12}>
                        <FHEItemText itemTitle={Translator.translate('general.table.column.description')} itemContent={ticket.description} />
                    </Grid>
                </Grid>
            </FHEContainerForm>
        );
    };

    renderChildren = () => {
        const { ticket, nbRemainingLines, ticketsHistory } = this.state;
        const { profile, ticketId, history } = this.props;

        const rightTicketHistoryList = profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('ticketHistoryList');

        return (
            <Fragment>
                <FHETitle title={ticket.label} Icon={SvgTicket} />
                <FHEContainerScroll>
                    <Fragment>
                        {this.renderForm()}
                        {rightTicketHistoryList && (
                            <Fragment>
                                <FHEDivider title={Translator.translate(`generic.ticketing.history`)} />
                                <TicketHistory
                                    profile={profile}
                                    nbRemainingLines={nbRemainingLines}
                                    data={ticketsHistory}
                                    ticketId={ticketId}
                                    getMoreData={this.loadMoreTicketHistory}
                                />
                            </Fragment>
                        )}
                    </Fragment>
                </FHEContainerScroll>
            </Fragment>
        );
    };
    render() {
        const { error, loading } = this.state;
        return (
            <FHEContainer withBackIcon loading={loading} error={error} onClickFunc={this.getTicketDetailsAndHistory} onRender={this.renderChildren} />
        );
    }
}

function mapStateToProps(state, props) {
    const { history, match } = props;
    const ticketId = match.params.id;

    return {
        profile: state.data.user,
        ticketId,
        managements: state.environments[history.environment].data.Managements.get('list')
    };
}

const styles = theme => ({
    loadingContainer: {
        textAlign: 'center',
        margin: 20
    },
    loadMoreTicketHistory: {
        marginTop: 30,
        width: '100%',
        textAlign: 'center'
    },
    refreshTicketHistoryList: {
        width: '100%',
        marginBottom: 20,
        textAlign: 'center'
    },
    messageSender: {
        display: 'flex',
        flexWrap: 'nowrap',
        marginBottom: 30
    },
    buttonSendMessage: {
        marginLeft: 10
    },
    buttonSendMessageIcon: {
        marginLeft: 10
    },
    colorGrey400: {
        color: theme.palette.colors.grey400
    },
    date: {
        textAlign: 'center',
        marginTop: '20px',
        marginBottom: '20px'
    }
});

export default withRouter(
    renderEnvComponent(
        'scenes/Ticket/index',
        connect(
            mapStateToProps,
            (dispatch, ownProps) =>
                bindActionCreators(tools.mergePropsToAction(ownProps.history.environment, { getTicketDetails, getTicketHistory }), dispatch)
        )(withStyles(styles, { withTheme: true })(TicketDetail))
    )
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Ticket/details.js